module.exports = __webpack_public_path__ + "img/zbdb.fe5da8c6.svg";